const getSandboxTradeMedicData = state => state.sandboxTradeMedicData;

export default getSandboxTradeMedicData;